"use client";

import { c as _c } from "react/compiler-runtime";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v16-appRouter";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import type { Session } from "next-auth";
import React, { type ReactNode } from "react";
import "symbol-observable";
import { CookieConsentRoot } from "#/features/cookieConsent/ui/CookieConsentRoot";
import { ProjectBrowser } from "#/features/project/ui/ProjectBrowser/ProjectBrowser";
import { ProjectBrowserProvider } from "#/features/project/ui/ProjectBrowser/ProjectBrowserContext";
import { type I18nProps } from "#/i18n/getI18nProps";
import type { Locales } from "#/i18n/i18n-types";
import { AppShellProviders } from "#/shared/ui/providers/AppShellProviders";
import { AppRouterI18nProvider } from "#/shared/ui/providers/I18nProvider";
import type { SsrDeviceType } from "#/themes";
type AppRootLayoutClientProps = {
  children: ReactNode;
  i18n: I18nProps;
  session: Session | null;
  locale: Locales;
  ssrDeviceType?: SsrDeviceType;
};

/**
 * App Router provider shell. Shares {@link AppShellProviders} with Pages `_app`.
 */
export const AppRootLayoutClient: React.FC<AppRootLayoutClientProps> = t0 => {
  const $ = _c(14);
  const {
    children,
    i18n,
    session,
    locale,
    ssrDeviceType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      key: "css"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ProjectBrowser />;
    t3 = <Analytics />;
    t4 = <SpeedInsights />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = <CookieConsentRoot><ProjectBrowserProvider>{children}{t2}{t3}{t4}</ProjectBrowserProvider></CookieConsentRoot>;
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== i18n || $[7] !== locale || $[8] !== t5) {
    t6 = <AppRouterI18nProvider locale={locale} i18n={i18n}>{t5}</AppRouterI18nProvider>;
    $[6] = i18n;
    $[7] = locale;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== session || $[11] !== ssrDeviceType || $[12] !== t6) {
    t7 = <AppRouterCacheProvider options={t1}><AppShellProviders session={session} ssrDeviceType={ssrDeviceType}>{t6}</AppShellProviders></AppRouterCacheProvider>;
    $[10] = session;
    $[11] = ssrDeviceType;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};